export default __webpack_public_path__ + "static/media/ic_jordan.8cb4bcb1.svg";